/**
 * @generated SignedSource<<e4d87c0c54269188aea3910045a0a36a>>
 * @relayHash 40bcb595f919202166f0037b79a49e67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a74a8edc9311504064535945cb3b6820e63b7fbfce4b80ddd169c71d22675623

import type { ConcreteRequest } from 'relay-runtime';
export type StarTemplateFavouriteStatusMutation$variables = {
  isFavourite: boolean;
  templateEntityId: string;
};
export type StarTemplateFavouriteStatusMutation$data = {
  readonly updateUserPreferences: {
    readonly favouriteTemplateEntityIds: ReadonlyArray<string | null>;
  } | null;
};
export type StarTemplateFavouriteStatusMutation = {
  response: StarTemplateFavouriteStatusMutation$data;
  variables: StarTemplateFavouriteStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFavourite"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateEntityId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "isFavourite",
                "variableName": "isFavourite"
              },
              {
                "kind": "Variable",
                "name": "templateEntityId",
                "variableName": "templateEntityId"
              }
            ],
            "kind": "ObjectValue",
            "name": "templateEntityFavouriteStatus"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "favouriteTemplateEntityIds"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StarTemplateFavouriteStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StarTemplateFavouriteStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40bcb595f919202166f0037b79a49e67",
    "id": "a74a8edc9311504064535945cb3b6820e63b7fbfce4b80ddd169c71d22675623",
    "metadata": {},
    "name": "StarTemplateFavouriteStatusMutation",
    "operationKind": "mutation",
    "text": "mutation StarTemplateFavouriteStatusMutation($isFavourite:Boolean!,$templateEntityId:String!){updateUserPreferences(userPreferences:{templateEntityFavouriteStatus:{isFavourite:$isFavourite,templateEntityId:$templateEntityId}}){favouriteTemplateEntityIds}}"
  }
};
})();

(node as any).hash = "93b3caaa701852fd7c778b8b1736cc7e";

export default node;
